
// Statü değerleri
export const statusEnumArray = [
  'NeedsReview',
  'Updated',
  'Approved'
];

export const getStatusLabel = (status: number | string | undefined): string => {
  if (status === undefined) return 'Needs Review';
  
  // String değerler için
  if (typeof status === 'string') {
    switch (status) {
      case 'NeedsReview':
        return 'Needs Review';
      case 'Updated':
        return 'Updated';
      case 'Approved':
        return 'Approved';
      default:
        return 'Needs Review';
    }
  }
  
  // Number değerler için (eski uyumluluk)
  switch (Number(status)) {
    case 0:
      return 'Needs Review';
    case 1:
      return 'Updated';
    case 2:
      return 'Approved';
    default:
      return 'Needs Review';
  }
};

export const getStatusColor = (status: number | string | undefined): string => {
  if (status === undefined) return "#FFC108"; // NeedsReview rengi
  
  // String değerler için
  if (typeof status === 'string') {
    switch (status) {
      case 'NeedsReview':
        return "#FFC108"; // NeedsReview - Sarı
      case 'Updated':
        return "#E91E63"; // Updated - Pembe
      case 'Approved':
        return "var(--app-accent-color)"; // Approved - Accent
      default:
        return "#FFC108"; // NeedsReview rengi
    }
  }
  
  // Number değerler için (eski uyumluluk)
  switch (Number(status)) {
    case 0:
      return "#FFC108"; // NeedsReview - Sarı
    case 1:
      return "#E91E63"; // Updated - Pembe
    case 2:
      return "#00C271"; // Approved - Accent Green
    default:
      return "#FFC108"; // NeedsReview rengi
  }
}; 